<template>
  <ComponentHeader title="Survey Questions" subtitle="Manage survey questions, instruments, and their relationships. Create reusable questions that can be dynamically assembled into surveys.">
    <template #bottom>
      <Page_Tabs
        class="px-4"
        :tabs="tabLabels"
        :initial-tab="activeTabLabel"
        no-border
        @select="handleTabSelect"
      />
    </template>
  </ComponentHeader>

  <div class="survey-questions-admin p-4">
    <!-- Tab Content -->
    <QuestionLibrary v-if="activeSubTab === 'questions'" @refresh="fetchData" />
    <InstrumentLibrary v-if="activeSubTab === 'instruments'" @refresh="fetchData" />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import QuestionLibrary from './QuestionLibrary.vue';
import InstrumentLibrary from './InstrumentLibrary.vue';
import ComponentHeader from '@/components/widgetcomponents/library/ComponentHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

export default {
  name: 'SurveyQuestions_Admin',

  components: {
    FontAwesomeIcon,
    QuestionLibrary,
    InstrumentLibrary,
    ComponentHeader,
    Page_Tabs
  },

  data() {
    return {
      activeSubTab: 'questions',
      subTabs: [
        { key: 'questions', label: 'Questions' },
        { key: 'instruments', label: 'Instruments' }
      ]
    };
  },

  computed: {
    tabLabels() {
      return this.subTabs.map(t => t.label);
    },
    activeTabLabel() {
      const tab = this.subTabs.find(t => t.key === this.activeSubTab);
      return tab ? tab.label : this.subTabs[0].label;
    }
  },

  methods: {
    handleTabSelect(label) {
      const tab = this.subTabs.find(t => t.label === label);
      if (tab) this.activeSubTab = tab.key;
    },
    fetchData() {
      // Refresh all child components
      this.$emit('refresh');
    }
  }
};
</script>

<style scoped>
</style>
